<!--suppress HtmlDeprecatedAttribute -->
<div id="assignmentContainer" style="width: auto"
  [hidden]="!assignment.isLoaded || classroom.selectedBoardTab !== ViewportTab.ASSIGNMENT">
  <iframe class="homework-frame" id="assignmentFrame" *ngIf="assignment.isLoaded"
    frameborder="0" scrolling="0"
    (load)="assignmentLoadedHandler()"
    [src]="safeURL">
  </iframe>
</div>
